"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabButtonsContainer = void 0;
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.TabButtonsContainer = (0, styled_components_1.default)(ui_1.ScrollView) `
  flex-shrink: 0;

  box-sizing: border-box;

  height: 80px;

  border-color: ${({ theme }) => theme.thinLine};
  border-style: solid;
  border-width: ${({ $isMobile }) => ($isMobile ? '0' : '0 1px 0')};
`;
